import CarouselControls from "@components/molecules/common/CarouselControls";
import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";
export default function GuideCards({ data }) {
  const Card = ({ data }) => {
    return (
      <a
        className="btn-outline bg:hover-white hover-review-card"
        href={data.href}
      >
        <figure>
          <picture>
            <source
              srcSet={`${data.image.src}.webp, ${data.image.src}-2x.webp 2x`}
              type="image/webp"
            />
            <source
              srcSet={`${data.image.src}.png, ${data.image.src}-2x.png 2x`}
              type="image/png"
            />
            <img
              loading="lazy"
              src={`${data.image.src}.png`}
              alt={data.image.alt}
              width="360"
              height="172"
            />
          </picture>
        </figure>
        <div>
          <h3 className="lg:mb-2 md:mb-1.5">{data.title}</h3>
          <p>{data.desc}</p>
        </div>
        <style jsx>{`
          div {
            text-align: left;
            padding: 24px 24px 36px 24px;
          }
          a {
            padding: 0;
            min-width: 295px;
            max-width: 360px;
          }
          img {
            height: auto;
          }
          @media (max-width: ${viewport.tablet.sm}) {
            div {
              padding: 16px 20px 36px;
            }
          }
        `}</style>
      </a>
    );
  };
  const ViewMoreCard = () => {
    return (
      <a
        className="fx fx--ch fx--cv btn-outline bg:hover-white text-brandcolor fw-700"
        href={data.hasOwnProperty("viewmore") ? data.viewmore.href : "/guides"}
      >
        <p>
          {data.hasOwnProperty("viewmore")
            ? data.viewmore.text
            : "View all guides"}
        </p>
        <style jsx>{`
          a {
            display: flex;
            padding: 0;
            min-width: 295px;
            max-width: 360px;
          }
        `}</style>
      </a>
    );
  };
  return (
    <div className="carousel-cont guides-card">
      <div className="carousel fx card--default has-three-col">
        {data.list.map((item, count) => {
          return <Card key={count} data={item} />;
        })}
        <ViewMoreCard />
      </div>
      <CarouselControls totalCarousels={data.list.length} />
      <style jsx>
        {`
          @media (max-width: ${viewport.tablet.sm}) {
            .guides-card .carousel {
              width: 1575px !important;
            }
          }
        `}
      </style>
    </div>
  );
}
